import React from 'react';
import PropTypes from 'prop-types';
import Story from '../../../StoryCheckerResult';

const StoryCheckerResultList = (props) => {
  const {
    styles = {},
    results,
    searchType,
    campaignName,
    profiles,
    filters,
    filterHandler,
    storyTextTitle,
    selectedSource
  } = props;
  const stories = results.reduce((components, story, i) => {
    const {
      matchingProfileIds,
      nonMatchingProfileIds,
      url,
      title,
      body
    } = story;

    let { isValid } = story;
    if (typeof isValid === 'undefined') {
      isValid = true; // ENG-7371
    }
    const showResult = filterHandler(filters, story);

    const onProfileClick = (profileId) => {
      const detailRequest = {
        profileId,
        title,
        body,
        url,
        sourceType: selectedSource
      };
      props.detailHandler(detailRequest);
    };

    if(showResult) {
      components.push(
        <div className={styles.sourceWrapper} key={`story-result-${i}`}>
          <Story
            title={url ? url : storyTextTitle}
            onProfileClick={onProfileClick}
            isCovered={matchingProfileIds.length > 0}
            isValid={isValid}
            campaignName={campaignName}
            matchingProfiles={matchingProfileIds}
            nonMatchingProfiles={nonMatchingProfileIds}
            profiles={profiles}
            searchType={searchType}
          />
        </div>
      );
    }
    return components;
  }, []);

  return (
    <div className={styles.listWrapper}>
      {stories}
    </div>
  );
};

StoryCheckerResultList.propTypes = {
  styles: PropTypes.object,
  filters: PropTypes.object,
  stories: PropTypes.array,
  results: PropTypes.array,
  profiles: PropTypes.array,
  filterHandler: PropTypes.func,
  searchType: PropTypes.oneOf(['url', 'storyText']),
  campaignName: PropTypes.string,
  storyTextTitle: PropTypes.string,
  detailHandler: PropTypes.func,
  selectedSource: PropTypes.string
};

export default StoryCheckerResultList;
